<template>
  <div class="mt-2">
    <!-- heading starts -->
    <!-- <v-row class="mt-1 mx-1" align-content="space-between">
      <v-col cols="12" md="12" sm="12">
        <p class="body-2 text--primary text-center">
          <v-icon color="red">mdi-bullseye-arrow</v-icon>
          Live DFS Player Pools From Our Professionals!
        </p>
        &nbsp;
      </v-col>
      <span class="mx-2 mt-n5">
        See what players our pros are watching and use those players to help
        your lineups!
      </span>
    </v-row> -->
    <!-- heading ends -->

    <v-row class="ma-2">
      <!-- card 1 -->
      <v-col cols="12" md="4" sm="12">
        <v-hover v-slot="{ hover }">
          <v-card class="mx-auto mt-5" rounded :elevation="hover ? 8 : 2">
            <v-card-text>
              <div></div>
              <p class="text-h6 text--primary text-center">Coming Soon...</p>
              <!-- <p class="blue--text body-2 text-center">
                Add Blazo's Player Pool to My Watchlist
              </p> -->
              <!-- <div class="text--primary">
                Last Updated: January 26, 2021 @ 07:35 AM Current Total NBA
                Players in Pool: 6
              </div> -->
            </v-card-text>
            <!-- <v-card-actions>
              <v-btn text color="teal accent-4" @click="reveal = true">
                Hide/Show Picks
              </v-btn>
            </v-card-actions> -->

            <v-expand-transition>
              <v-card
                v-if="reveal"
                class="transition-fast-in-fast-out v-card--reveal"
                style="height: 100%"
              >
                <v-card-text class="pb-0">
                  <p class="display-1 text--primary">Origin</p>
                  <p>
                    late 16th century (as a noun denoting a place where alms
                    were distributed): from medieval Latin eleemosynarius, from
                    late Latin eleemosyna ‘alms’, from Greek eleēmosunē
                    ‘compassion’
                  </p>
                </v-card-text>
                <!-- <v-card-actions class="pt-0">
                  <v-btn text color="teal accent-4" @click="reveal = false">
                    Close
                  </v-btn>
                </v-card-actions> -->
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-hover>
      </v-col>
      <!-- card 1 ends-->

      <!-- card 2 -->
      <v-col cols="12" md="4" sm="12">
        <v-hover v-slot="{ hover }">
          <v-card class="mx-auto mt-5" rounded :elevation="hover ? 8 : 2">
            <v-card-text>
              <div></div>
              <p class="text-h6 text--primary text-center">Coming Soon...</p>
              <!-- <p class="text-h6 text--primary text-center">
                Island Dave's Picks...
              </p> -->
              <!-- <p class="blue--text body-2 text-center">
                Add Dave's Player Pool to My Watchlist
              </p> -->
              <!-- <div class="text--primary text-center">
                Last Updated: January 25, 2021 Current Total NBA Players in
                Pool:&nbsp;0<br />
                Waiting for Dave to make picks...
              </div> -->
            </v-card-text>
            <!-- <v-card-actions>
              <v-btn text color="teal accent-4" @click="reveal2 = true">
                Hide/Show Picks
              </v-btn>
            </v-card-actions> -->

            <v-expand-transition>
              <v-card
                v-if="reveal2"
                class="transition-fast-in-fast-out v-card--reveal"
                style="height: 100%"
              >
                <v-card-text class="pb-0">
                  <p class="display-1 text--primary">Origin</p>
                  <p>
                    late 16th century (as a noun denoting a place where alms
                    were distributed): from medieval Latin eleemosynarius, from
                    late Latin eleemosyna ‘alms’, from Greek eleēmosunē
                    ‘compassion’
                  </p>
                </v-card-text>
                <!-- <v-card-actions class="pt-0">
                  <v-btn text color="teal accent-4" @click="reveal2 = false">
                    Close
                  </v-btn>
                </v-card-actions> -->
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-hover>
      </v-col>
      <!-- card 2 ends-->

      <!-- card 3 -->
      <v-col cols="12" md="4" sm="12">
        <v-hover v-slot="{ hover }">
          <v-card class="mx-auto mt-5" :elevation="hover ? 8 : 2">
            <v-card-text>
              <div></div>
              <p class="text-h6 text--primary text-center">Coming Soon...</p>
              <!-- <p class="text-h6 text--primary text-center">
                Jerry The Bull's Picks...
              </p> -->
              <!-- <p class="blue--text body-2 text-center">
                Add Jerry's Player Pool to My Watchlist
              </p> -->
              <!-- <div class="text--primary text-center">
                Last Updated: January 25, 2021 Current Total NBA Players in
                Pool:&nbsp; 0<br />
                Waiting for Jerry to make picks...
              </div> -->
            </v-card-text>
            <!-- <v-card-actions>
              <v-btn text color="teal accent-4" @click="reveal3 = true">
                Hide/Show Picks
              </v-btn>
            </v-card-actions> -->

            <v-expand-transition>
              <v-card
                v-if="reveal3"
                class="transition-fast-in-fast-out v-card--reveal"
                style="height: 100%"
              >
                <v-card-text class="pb-0">
                  <p class="display-1 text--primary">Origin</p>
                  <p>
                    late 16th century (as a noun denoting a place where alms
                    were distributed): from medieval Latin eleemosynarius, from
                    late Latin eleemosyna ‘alms’, from Greek eleēmosunē
                    ‘compassion’
                  </p>
                </v-card-text>
                <!-- <v-card-actions class="pt-0">
                  <v-btn text color="teal accent-4" @click="reveal3 = false">
                    Close
                  </v-btn>
                </v-card-actions> -->
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-hover>
      </v-col>
      <!-- card 3 ends-->
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    reveal: false,
    reveal2: false,
    reveal3: false,
  }),
};
</script>

<style scoped>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>
